import { useMutation } from '@tanstack/react-query';
import { GET, GET_INCENTIVE_HISTORY } from '../../../services';

export const useGetScanHistory = () => {
  const { mutate, data, isPending } = useMutation({
    mutationFn: async (employeeId) => {
      const response = await GET(GET_INCENTIVE_HISTORY(employeeId));
      return response;
    },
  });

  return {
    mutate,
    data,
    isPending,
  };
};
